import React, { } from "react";
import { Modal } from "antd";
import Container from "../../General/Container/Container";
import { useDispatch } from "react-redux";
import { setVisibleRecomInsights } from "../../../store/components/Minified.slice";
import MinifiedInsightsTitle from "./MinifiedInsightsTitle";
import MinifiedInsightsGender from "./MinifiedInsightsGender";
import MinifiedInsightsText from "./MinifiedInsightsText";
import MinifiedInsightsAge from "./MinifiedInsightsAge";
import useGetMinifiedInsightsData from "../../../hooks/minified/useGetMinifiedInsightsData";

function MinifiedInsightsDetailsModal() {
    const dispatch = useDispatch()
    const {
        isLoading,
        simpleSummaryValue,
        genderData,
        ageData,
        visible,
        colors,
        data
    } = useGetMinifiedInsightsData()

    const onClose = () => {
        dispatch(setVisibleRecomInsights({
            data: null,
            visible: false
        }));
    }

    return (
        <Modal
            width={1200}
            height={700}
            centered
            className="minified-insights"
            visible={visible}
            maskClosable={false}
            title={<MinifiedInsightsTitle data={data} />}
            footer={null}
            onCancel={onClose}
        >
            <Container style={{
                height: "calc(100% - 4mm)",
                overflowY: "auto",
                backgroundColor: "#F9FAFB",
                padding: "2mm 5mm 2mm 5mm",
                borderRadius: "4px"
            }}>
                <Container className="drow fullw align-center justify-center" style={{
                    padding: "5mm 0",
                    backgroundColor: "white",
                    height: "55%"
                }}>
                    {/* <MinifiedInsightsGender loading={isLoading} data={genderData} />
                    <div style={{ height: "100%", border: "1px solid #E2E8F0", width: "1px" }} /> */}
                    <MinifiedInsightsAge loading={isLoading} data={ageData} colors={colors} />
                </Container>
                <MinifiedInsightsText loading={isLoading} text={simpleSummaryValue} />
            </Container>
        </Modal>
    );
}

export default MinifiedInsightsDetailsModal;
